import React from 'react';

type Props = {
  className?: string;
};

const PPMConfettiBackground: React.FC<Props> = ({ className = '' }) => (
  <span aria-hidden="true" className={`block ${className}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 190"
      fill="none"
      preserveAspectRatio="none"
      className="absolute inset-0 h-full w-full"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H306C308.209 0 310 1.79086 310 4V166C310 168.209 308.209 170 306 170H4C1.79086 170 0 168.209 0 166V4Z"
        fill="#F6F6F6"
      />

      <mask id="ppmConfettiMask" maskUnits="userSpaceOnUse" x="0" y="0" width="310" height="170">
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0H306C308.209 0 310 1.79086 310 4V166C310 168.209 308.209 170 306 170H4C1.79086 170 0 168.209 0 166V4Z"
          fill="#EFF9FE"
        />
      </mask>

      <g mask="url(#ppmConfettiMask)">
        <path
          d="M311.541 70C310.436 70 309.541 70.8954 309.541 72C309.541 73.1046 310.436 74 311.541 74C312.646 74 313.541 73.1046 313.541 72C313.541 70.8954 312.646 70 311.541 70Z"
          fill="#0075C9"
        />
        <path
          d="M293.541 31C292.436 31 291.541 31.8954 291.541 33C291.541 34.1046 292.436 35 293.541 35C294.646 35 295.541 34.1046 295.541 33C295.541 31.8954 294.646 31 293.541 31Z"
          fill="#89CDDA"
        />
        <path
          d="M288.541 79C288.541 82 283.541 82 283.541 85C283.541 88 288.541 88 288.541 91C288.541 94 283.541 94 283.541 97C283.541 100 288.541 100 288.541 103C288.541 106 283.541 106 283.541 109"
          stroke="#D8E4F3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M287.541 140C287.541 143.465 282 143.465 282 146.931C282 150.396 287.541 150.396 287.541 153.861C287.541 157.327 282 157.327 282 160.792C282 164.257 287.541 164.257 287.541 167.722C287.541 171.188 282 171.188 282 174.653"
          stroke="#89CDDA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M252.77 25.5444C254.301 25.5444 255.541 24.3033 255.541 22.7722C255.541 21.2412 254.301 20 252.77 20C251.24 20 250 21.2412 250 22.7722C250 24.3033 251.24 25.5444 252.77 25.5444Z"
          fill="#0075C9"
        />
        <path
          d="M270 50C270 45.3 274 45.3 274 40.6C274 35.9 270 35.9 270 31.2C270 26.5 274 26.5 274 21.8C274 17.1 270 17.1 270 12.4C270 7.7 274 7.7 274 3"
          stroke="#D8E4F3"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-1 197C-1 190.9 5 190.9 5 184.8C5 178.7 -1 178.7 -1 172.6C-1 166.5 5 166.5 5 160.4C5 154.3 -1 154.3 -1 148.2C-1 142.1 5 142.1 5 136"
          stroke="#89CDDA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 110C7.10457 110 8 109.105 8 108C8 106.895 7.10457 106 6 106C4.89543 106 4 106.895 4 108C4 109.105 4.89543 110 6 110Z"
          fill="#0075C9"
        />
        <path
          d="M24 149C25.1046 149 26 148.105 26 147C26 145.895 25.1046 145 24 145C22.8954 145 22 145.895 22 147C22 148.105 22.8954 149 24 149Z"
          fill="#89CDDA"
        />
        <path
          d="M29 89C29 86 34 86 34 83C34 80 29 80 29 77C29 74 34 74 34 71C34 68 29 68 29 65C29 62 34 62 34 59"
          stroke="#D8E4F3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 48.6526C30 45.1874 35.5409 45.1874 35.5409 41.7221C35.5409 38.2568 30 38.2568 30 34.7916C30 31.3263 35.5409 31.3263 35.5409 27.8611C35.5409 24.3958 30 24.3958 30 20.9305C30 17.4653 35.5409 17.4653 35.5409 14"
          stroke="#89CDDA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-2 62.6526C-2 59.1874 3.54094 59.1874 3.54094 55.7221C3.54094 52.2568 -2 52.2568 -2 48.7916C-2 45.3263 3.54094 45.3263 3.54094 41.8611C3.54094 38.3958 -2 38.3958 -2 34.9305C-2 31.4653 3.54094 31.4653 3.54094 28"
          stroke="#F7B40A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M48.8275 38.9998L46 41.8291L48.8275 44.6584L51.6551 41.8291L48.8275 38.9998Z" fill="#F7A7A8" />
      </g>
    </svg>
  </span>
);

export default PPMConfettiBackground;
